import React from 'react';

import { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons16px/Calendar.svg';
import { ReactComponent as CommentIcon } from '../../../../assets/icons16px/Comment.svg';
import { ReactComponent as StatLinkIcon } from '../../../../assets/icons8px/StatLink.svg';
import { ReactComponent as StatNegIcon } from '../../../../assets/icons8px/StatNeg.svg';
import { ReactComponent as StatPosIcon } from '../../../../assets/icons8px/StatPos.svg';



export type CustomIconProps = {
  icon: IconTypes;
};

export type IconTypes =
  'STATPOS' |
  'STATNEG' |
  'STATLINK' |
  'COMMENT' |
  'CALENDAR';



export const __icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  STATPOS: <StatPosIcon />,
  STATNEG: <StatNegIcon />,
  STATLINK: <StatLinkIcon />,
  COMMENT: <CommentIcon />,
  CALENDAR: <CalendarIcon />

};

export const FC = (props: CustomIconProps & SvgIconProps) => {
  const Res = __icon2iconUrl[props.icon];

  return (

    <Res.type {...props} />

  );
};
